<template lang="pug">
    .checkout-page
        .main-area
            section.container.mx-auto
                CheckoutStepper(:areas="areas")
</template>

<script>
// import { mapGetters } from 'vuex';

import Page from '@/views/Page';

// import Heading from '@/components/Heading';
// import Post from '@/components/Post';
import CheckoutStepper from '@/extensions/shop/components/CheckoutStepper';

export default {
    name: 'Checkout',
    extends: Page,
    components: {
        // Heading,
        // Post,
        CheckoutStepper
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
// @import "~@/assets/sass/variables"

section.container
    @apply my-8 px-4

section.slider,
section.banners
    padding: 0
section.heading
    padding-bottom: 0
</style>
